import { Modal } from 'ui/dialog/modal/modal';
import h from 'hyperscript';

import i18n from './messages.properties';

export class GazetteerConfirmDialog extends Modal {

  constructor (item) {
    super();
    this.heading = i18n('outOfMapAreaOfUse.heading');
    this.body.append(h('div', i18n('outOfMapAreaOfUse.message')));
    this.footer.append(
      this._okButton = h('button.button.button-primary', { type: 'submit' }, i18n('common:yes')),
      h('button.button.cancel', { type: 'button' }, i18n('common:cancel')));
    this.addEventListener('submit',
      () => {
        this.close(true);
      });
  }

}

customElements.define('d-gazetteer-confirm-dialog', GazetteerConfirmDialog);
